// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mind Map Container */
.mindmap-container {
  width: 100%;
  height: 600px;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.mindmap-flow {
  width: 100%;
  height: 100%;
  position: relative;
}

/* No Mind Map State */
.no-mindmap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: white;
  text-align: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
}

.no-mindmap-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  animation: pulse 2s infinite;
}

.no-mindmap p {
  font-size: 1.2rem;
  margin: 0;
  opacity: 0.9;
}

/* Custom Node Styles */
.mindmap-node {
  position: relative;
  border-radius: 16px;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.1s ease-out;
  cursor: grab;
  overflow: hidden;
}

.mindmap-node:active {
  cursor: grabbing;
  transform: scale(1.02);
}

.mindmap-node.selected {
  transform: scale(1.05);
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
}

/* Root Node */
.root-node {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);
  min-width: 220px;
  min-height: 60px;
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
}

.root-node:hover {
  transform: translateY(-2px) scale(1.01);
  box-shadow: 0 18px 38px rgba(102, 126, 234, 0.4);
}

.root-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  color: white;
  text-align: center;
  position: relative;
  z-index: 2;
}

.root-content .node-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.node-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  animation: rotate 8s linear infinite;
  pointer-events: none;
}

/* Category Node */
.category-node {
  background: linear-gradient(135deg, rgba(17, 153, 142, 0.9) 0%, rgba(56, 239, 125, 0.9) 100%);
  min-width: 180px;
  min-height: 50px;
  box-shadow: 0 12px 25px rgba(17, 153, 142, 0.25);
}

.category-node:hover {
  transform: translateY(-2px) scale(1.01);
  box-shadow: 0 14px 28px rgba(17, 153, 142, 0.35);
}

.category-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  color: white;
  text-align: center;
  position: relative;
  z-index: 2;
}

.category-content .node-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}

.node-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: pulse 3s ease-in-out infinite;
  pointer-events: none;
}

/* Subtopic Node */
.subtopic-node {
  background: linear-gradient(135deg, rgba(255, 154, 158, 0.9) 0%, rgba(254, 207, 239, 0.9) 100%);
  min-width: 140px;
  min-height: 40px;
  box-shadow: 0 8px 20px rgba(255, 107, 107, 0.2);
}

.subtopic-node:hover {
  transform: translateY(-1px) scale(1.01);
  box-shadow: 0 10px 22px rgba(255, 107, 107, 0.3);
}

.subtopic-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  color: #2d3748;
  text-align: center;
  position: relative;
  z-index: 2;
}

.subtopic-content .node-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

.node-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 3s ease-in-out infinite;
  pointer-events: none;
}

/* Custom Handles */
.custom-handle {
  width: 12px;
  height: 12px;
  border: 2px solid white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.root-handle {
  background: linear-gradient(135deg, #667eea, #764ba2);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

.category-handle {
  background: linear-gradient(135deg, #11998e, #38ef7d);
  box-shadow: 0 2px 6px rgba(17, 153, 142, 0.4);
}

.subtopic-handle {
  background: linear-gradient(135deg, #ff9a9e, #fecfef);
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.4);
}

.custom-handle:hover {
  transform: scale(1.3);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
}

/* Custom Controls */
.custom-controls {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px;
}

.custom-controls button {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.custom-controls button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

/* Custom MiniMap */
.custom-minimap {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  overflow: hidden;
}

/* Custom Background */
.custom-background {
  opacity: 0.3;
}

/* Animations */
@keyframes pulse {
  0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 0.1; transform: translate(-50%, -50%) scale(1.2); }
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

/* Responsive Design */
@media (max-width: 768px) {
  .mindmap-container {
    height: 500px;
    border-radius: 16px;
  }
  
  .root-node {
    min-width: 180px;
    min-height: 50px;
  }
  
  .category-node {
    min-width: 150px;
    min-height: 40px;
  }
  
  .subtopic-node {
    min-width: 120px;
    min-height: 35px;
  }
  
  .root-content .node-text {
    font-size: 14px;
  }
  
  .category-content .node-text {
    font-size: 12px;
  }
  
  .subtopic-content .node-text {
    font-size: 11px;
  }
}

/* React Flow Overrides */
.react-flow__node {
  cursor: grab;
}

.react-flow__node:active {
  cursor: grabbing;
}

.react-flow__node.selected {
  box-shadow: none;
}

.react-flow__edge {
  cursor: default;
}

.react-flow__edge-path {
  stroke-width: 2;
  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.1));
}

.react-flow__arrowhead {
  fill: currentColor;
} `, "",{"version":3,"sources":["webpack://./src/components/MindMap.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,0CAA0C;EAC1C,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,8FAA8F;EAC9F,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,6FAA6F;EAC7F,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,+FAA+F;EAC/F,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,WAAW,YAAY,EAAE,yCAAyC,EAAE;EACpE,MAAM,YAAY,EAAE,2CAA2C,EAAE;AACnE;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* Mind Map Container */\n.mindmap-container {\n  width: 100%;\n  height: 600px;\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mindmap-flow {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n/* No Mind Map State */\n.no-mindmap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: white;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n}\n\n.no-mindmap-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  animation: pulse 2s infinite;\n}\n\n.no-mindmap p {\n  font-size: 1.2rem;\n  margin: 0;\n  opacity: 0.9;\n}\n\n/* Custom Node Styles */\n.mindmap-node {\n  position: relative;\n  border-radius: 16px;\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.1s ease-out;\n  cursor: grab;\n  overflow: hidden;\n}\n\n.mindmap-node:active {\n  cursor: grabbing;\n  transform: scale(1.02);\n}\n\n.mindmap-node.selected {\n  transform: scale(1.05);\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n}\n\n/* Root Node */\n.root-node {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);\n  min-width: 220px;\n  min-height: 60px;\n  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);\n}\n\n.root-node:hover {\n  transform: translateY(-2px) scale(1.01);\n  box-shadow: 0 18px 38px rgba(102, 126, 234, 0.4);\n}\n\n.root-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 20px;\n  color: white;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n.root-content .node-text {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.node-glow {\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n  animation: rotate 8s linear infinite;\n  pointer-events: none;\n}\n\n/* Category Node */\n.category-node {\n  background: linear-gradient(135deg, rgba(17, 153, 142, 0.9) 0%, rgba(56, 239, 125, 0.9) 100%);\n  min-width: 180px;\n  min-height: 50px;\n  box-shadow: 0 12px 25px rgba(17, 153, 142, 0.25);\n}\n\n.category-node:hover {\n  transform: translateY(-2px) scale(1.01);\n  box-shadow: 0 14px 28px rgba(17, 153, 142, 0.35);\n}\n\n.category-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 16px;\n  color: white;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n.category-content .node-text {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.node-pulse {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  animation: pulse 3s ease-in-out infinite;\n  pointer-events: none;\n}\n\n/* Subtopic Node */\n.subtopic-node {\n  background: linear-gradient(135deg, rgba(255, 154, 158, 0.9) 0%, rgba(254, 207, 239, 0.9) 100%);\n  min-width: 140px;\n  min-height: 40px;\n  box-shadow: 0 8px 20px rgba(255, 107, 107, 0.2);\n}\n\n.subtopic-node:hover {\n  transform: translateY(-1px) scale(1.01);\n  box-shadow: 0 10px 22px rgba(255, 107, 107, 0.3);\n}\n\n.subtopic-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 14px;\n  color: #2d3748;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n.subtopic-content .node-text {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.node-shimmer {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  animation: shimmer 3s ease-in-out infinite;\n  pointer-events: none;\n}\n\n/* Custom Handles */\n.custom-handle {\n  width: 12px;\n  height: 12px;\n  border: 2px solid white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.root-handle {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);\n}\n\n.category-handle {\n  background: linear-gradient(135deg, #11998e, #38ef7d);\n  box-shadow: 0 2px 6px rgba(17, 153, 142, 0.4);\n}\n\n.subtopic-handle {\n  background: linear-gradient(135deg, #ff9a9e, #fecfef);\n  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.4);\n}\n\n.custom-handle:hover {\n  transform: scale(1.3);\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.6);\n}\n\n/* Custom Controls */\n.custom-controls {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 8px;\n}\n\n.custom-controls button {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.custom-controls button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n/* Custom MiniMap */\n.custom-minimap {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Custom Background */\n.custom-background {\n  opacity: 0.3;\n}\n\n/* Animations */\n@keyframes pulse {\n  0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(1); }\n  50% { opacity: 0.1; transform: translate(-50%, -50%) scale(1.2); }\n}\n\n@keyframes rotate {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes shimmer {\n  0% { left: -100%; }\n  100% { left: 100%; }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .mindmap-container {\n    height: 500px;\n    border-radius: 16px;\n  }\n  \n  .root-node {\n    min-width: 180px;\n    min-height: 50px;\n  }\n  \n  .category-node {\n    min-width: 150px;\n    min-height: 40px;\n  }\n  \n  .subtopic-node {\n    min-width: 120px;\n    min-height: 35px;\n  }\n  \n  .root-content .node-text {\n    font-size: 14px;\n  }\n  \n  .category-content .node-text {\n    font-size: 12px;\n  }\n  \n  .subtopic-content .node-text {\n    font-size: 11px;\n  }\n}\n\n/* React Flow Overrides */\n.react-flow__node {\n  cursor: grab;\n}\n\n.react-flow__node:active {\n  cursor: grabbing;\n}\n\n.react-flow__node.selected {\n  box-shadow: none;\n}\n\n.react-flow__edge {\n  cursor: default;\n}\n\n.react-flow__edge-path {\n  stroke-width: 2;\n  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.1));\n}\n\n.react-flow__arrowhead {\n  fill: currentColor;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
